var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_icon",
    transform: "translate(-0.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(0.46)",
    fill: "#5e2b97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M14.373,8.953A8.052,8.052,0,0,0,7.23,4.5,8.053,8.053,0,0,0,.087,8.954a.812.812,0,0,0,0,.733A8.052,8.052,0,0,0,7.23,14.14a8.053,8.053,0,0,0,7.143-4.454.812.812,0,0,0,0-.733ZM7.23,12.935A3.615,3.615,0,1,1,10.845,9.32,3.615,3.615,0,0,1,7.23,12.935Zm0-6.025a2.393,2.393,0,0,0-.635.1,1.2,1.2,0,0,1-1.68,1.675A2.4,2.4,0,1,0,7.23,6.91Z",
    transform: "translate(5 2.86)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.ccaadff42f6208413b423c849515fbe0.svg";
export { ForwardRef as ReactComponent };